import { render } from "./Culture.vue?vue&type=template&id=fd8aae78&scoped=true&lang=pug"
import script from "./Culture.vue?vue&type=script&setup=true&lang=js"
export * from "./Culture.vue?vue&type=script&setup=true&lang=js"

import "./Culture.vue?vue&type=style&index=0&id=fd8aae78&lang=stylus&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd8aae78"]])

export default __exports__